export default __webpack_public_path__ + "static/media/button_closed_section.8effea3f.svg";